<template>
  <div class="screen">
    <div v-if="lastEvaluation" class="last-evaluation">
      <div class="last-evaluation-content">
        <h6 class="text-capitalize student-name">
          {{ studentName }} - {{ lastEvaluation[0].grade_name }} -
          {{ lastEvaluation[0].created_at | englishDateNew }}
        </h6>
        <ul class="results">
          <li v-for="(item, index) in lastEvaluation" :key="index" class="results-item">
            <div class="subject-score">
              <span class="results-subject">{{ item.subject_name | deleteNumbers }}:</span>
              <span class="results-scores">
                <span>{{ item.average }}%</span> -
                <span>{{ item.average | evaluateByLetters }}</span>
              </span>
            </div>
            <div class="subject-name" :class="item.subject_name | deleteNumbers">
              <span></span>
              <label>{{ item.subject_name | deleteNumbers }}</label>
            </div>
          </li>
        </ul>
        <div class="graphs-results">
          <div class="graph">
            <ul class="section_score_wrapper" :class="{ active: scoresActive }">
              <li
                v-for="(item, index) in lastEvaluation"
                :key="index"
                class="section_score"
                :class="item.subject_name | deleteNumbers"
              >
                <div
                  :ref="index"
                  class="section-score-bar"
                  :class="{ active: barClassActive }"
                  :style="{ height: item.average + '%' }"
                >
                  <p class="section_score_num" :style="numsStyleActive ? 'opacity: 1;' : ''">
                    {{ item.average | parseInt }}
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="evaluations-record">
      <h1 v-if="!evaluations.length">{{ $t('previousResults.noHistory') }}</h1>
      <Swiper v-else ref="mySwiper" :options="swiperOptions" :auto-update="true">
        <SwiperSlide v-for="(item, index) in evaluations" :key="index">
          <div class="evaluation-record-content">
            <h6 class="text-capitalize student-name">
              {{ item[0].grade_name }} -
              {{ item[0].created_at | englishDateNew }}
            </h6>
            <ul class="results">
              <li v-for="(_item, _itemIndex) in item" :key="_itemIndex" class="results-item">
                <div class="subject-score">
                  <span class="results-subject">{{ _item.subject_name | deleteNumbers }}:</span>
                  <span class="results-scores">
                    <span>{{ _item.average }}%</span> -
                    <span>{{ _item.average | evaluateByLetters }}</span>
                  </span>
                </div>
                <div class="subject-name" :class="_item.subject_name | deleteNumbers">
                  <span></span>
                  <label>{{ _item.subject_name | deleteNumbers }}</label>
                </div>
              </li>
            </ul>
            <div class="graphs-results">
              <div class="graph">
                <ul class="section_score_wrapper" :class="{ active: scoresActive }">
                  <li
                    v-for="(_item, _index) in item"
                    :key="_index"
                    class="section_score"
                    :class="_item.subject_name | deleteNumbers"
                  >
                    <div
                      :ref="_index"
                      class="section-score-bar"
                      :class="{ active: barClassActive }"
                      :style="{ height: _item.average + '%' }"
                    >
                      <p class="section_score_num" :style="numsStyleActive ? 'opacity: 1;' : ''">
                        {{ _item.average | parseInt }}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <img
          slot="button-prev"
          class="swiper-button-prev"
          src="@/assets/carousel/Asset_28.png"
          alt
          height="58"
          width="21"
        />
        <img
          slot="button-next"
          class="swiper-button-next"
          src="@/assets/carousel/Asset_28_right.png"
          alt
          height="58"
          width="21"
        />
      </Swiper>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

export default {
  name: 'EvaluationList',
  components: {
    SwiperSlide,
    Swiper,
  },
  props: {
    studentName: {
      type: String,
      required: true,
    },
    studentId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      evaluations: [],
      lastEvaluation: {},
      numsStyleActive: false,
      scoresActive: false,
      barClassActive: false,
      swiperOptions: {
        keyboard: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        noSwiping: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          576: {
            slidesPerView: 'auto',
          },
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  created() {
    this.fetchEvaluations();
    setTimeout(() => {
      this.scoresActive = true;
      this.barClassActive = true;
    }, 500);
    setTimeout(() => {
      this.numsStyleActive = true;
    }, 1000);
  },
  methods: {
    fetchEvaluations() {
      this.$store.commit('START_PROCESSING');
      this.$httpMain
        .post('get_all_evaluations_per_student', {
          student_id: this.studentId,
        })
        .then(res => {
          // var evaluationsByTestID = _.groupBy(res.data, 'test_id');
          // evaluationsByTestID = Object.values(evaluationsByTestID);
          // evaluationsByTestID.forEach(element => {
          //   /** Agrupa las preguntas que estan en element por sublect_name */
          console.log(res.data.subjects);
          let items = _.groupBy(res.data.subjects, 'key');
          // });
          Object.keys(items).forEach(key => {
            // console.log(key, items[key]);
            this.evaluations.push({ ...items[key] });
          });
          console.log('evaluations', this.evaluations);
          this.lastEvaluation = this.evaluations.pop();
          console.log('lastEvaluation', this.lastEvaluation);
          this.$store.commit('STOP_PROCESSING');
        })
        .catch(err => {
          this.$store.commit('STOP_PROCESSING');
          console.log(err);
        });
    },
    getScore(subject) {
      var correctAnswers = 0;
      subject.forEach(element => {
        if (element.result === true) {
          correctAnswers++;
        }
      });
      /** Calcula el porcentaje de repuestas correctas */
      var value = (correctAnswers * 100) / _.size(subject);
      return value % 1 === 0 ? value : value.toFixed(2);
    },
  },
};
</script>
<style lang="sass" scoped>
.screen
  display: flex
  flex-wrap: wrap
  height: 100%
  padding: 0 1px
  +forDesktop
    padding-top: 5%
.last-evaluation
  width: 100%
  +forDesktop
    padding: 5px
    width: 50%
.last-evaluation-content
  max-width: 600px
  margin: auto
.evaluations-record
  width: 100%
  +forDesktop
    padding: 5px
    width: 50%
.evaluation-record-content
  max-width: 600px
  margin: auto
.student-name
  font-weight: 600
  line-height: 20px
.results
  display: flex
  align-items: center
  justify-content: center
  flex-direction: column
  min-height: 80px
  +forDesktop
    min-height: 150px
.results-item
  display: flex
  align-items: center
  justify-content: space-between
  width: 100%
  font-size: 12px
  flex-wrap: wrap
  padding: 1px 0
.subject-score
  display: flex
  flex-grow: 2
  flex-basis: 0
  justify-content: space-between
  width: 80%
  font-family: 'comfortaabold'
.subject-name
  display: flex
  align-items: center
  justify-content: flex-end
  width: 20%
.results-scores
  display: flex
  align-items: center
  justify-content: space-between
  min-width: 80px

.subject-name
  display: flex
  flex-grow: 1
  font-family: 'comfortaaregular'
  span
    display: inline-block
    width: 45px
    height: 15px
    border-radius: 3px
    margin-right: 10px
  label
    width: 70px
.subject-name.Pk span
  background-color: orange
.subject-name.Tk span
  background-color: #20c997
.subject-name.Math span
  background-color: #2693fc
.subject-name.Grammar span
  background-color: #f4cf14
.subject-name.Reading span
  background-color: #f50c0d
.subject-name.Science span
  background-color: #b51da3
.subject-name.Social.Studies span
  background-color: #2aaf0a
.subject-name.Vocabulary span
  background-color: #ff790b
.subject-name.American.History span
  background-color: #0052b7
.subject-name.Biology span
  background-color: #9ef835
.subject-name.Chemistry span
  background-color: #880b8b
.subject-name.Physics span
  background-color: #36c17d
.subject-name.World.Studies span
  background-color: #932f1d

.graphs-results
  display: flex
  align-items: center
  justify-content: center
  width: 100%
  height: 100px
  background-color: #c1ced8
  +forDesktop
    height: 250px
  .graph
    display: flex
    align-items: center
    justify-content: center
    flex-direction: column
    background-color: #c3cfd9
    border-radius: 5px
    margin-bottom: -15px
.section_score
  margin-right: 10px
  margin-bottom: 0
  &:last-child
    margin-right: 0
.section-score-bar
  width: 20px
  +forDesktop
    width: 40px
.section_score
  height: 70px
  display: flex
  flex-direction: column-reverse
  float: left
  position: relative
  text-align: center
  margin-right: 5px
  perspective: 1000px
  transition: all 0.3s ease-in-out
  +forDesktop
    height: 120px
.graph-title
  font-size: 15px
  color: #ffffff
  font-family: 'comfortaabold'
  margin-bottom: 5px
.section_score .section_label
  position: absolute
  bottom: -55px
  width: 100%
  font-size: 12px
  display: flex
  font-family: 'comfortaabold'
  align-items: center
  justify-content: center
  height: 40px
  line-height: 1
.section_score .section_score_num
  background-color: #fff
  border-radius: 50%
  width: 25px
  height: 25px
  padding: 4px
  display: inline-block
  border: 3px solid #a9a9a9
  position: relative
  top: -15px
  opacity: 0
  font-size: 10px
  font-weight: bold
  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1)
  display: flex
  align-items: center
  justify-content: center
  margin: 0 auto
.section_score:last-child
  margin-right: 0
.section_score.Tk
  background-color: rgba(orange, 0.25)
  .section-score-bar
    background-color: orange

.section_score.Tk
  background-color: rgba(#20c997, 0.25)
  .section-score-bar
    background-color: #20c997

.section_score.Math
  background-color: rgba(#2693fc, 0.25)
  .section-score-bar
    background-color: #2693fc

.section_score.Grammar
  background-color: rgba(#f4cf14, 0.25)
  .section-score-bar
    background-color: #f4cf14

.section_score.Reading
  background-color: rgba(#f50c0d, 0.25)
  .section-score-bar
    background-color: #f50c0d

.section_score.Science
  background-color: rgba(#b51da3, 0.25)
  .section-score-bar
    background-color: #b51da3

.section_score.Social.Studies
  background-color: rgba(#2aaf0a, 0.25)
  .section-score-bar
    background-color: #2aaf0a

.section_score.Vocabulary
  background-color: rgba(#ff790b, 0.25)
  .section-score-bar
    background-color: #ff790b

.section_score.American.History
  background-color: rgba(#0052b7, 0.25)
  .section-score-bar
    background-color: #0052b7

.section_score.Biology
  background-color: rgba(#9ef835, 0.25)
  .section-score-bar
    background-color: #9ef835

.section_score.Chemistry
  background-color: rgba(#880b8b, 0.25)
  .section-score-bar
    background-color: #880b8b

.section_score.Physics
  background-color: rgba(#36c17d, 0.25)
  .section-score-bar
    background-color: #36c17d

.section_score.World.Studies
  background-color: rgba(#932f1d, 0.25)
  .section-score-bar
    background-color: #932f1d
</style>
